import script from "./BmlrReportView.vue?vue&type=script&setup=true&lang=js"
export * from "./BmlrReportView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__